import React, {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {Play} from 'lucide-react'
import {sanity} from '../lib/sanity'

const placeholderImage = '/assets/images/placeholderEventImage.jpg'

const VIDEOS_QUERY = `*[
  _type == "video" &&
  defined(slug.current) &&
  videoFile.asset->status == "ready"
] | order(_createdAt desc) {
  _id,
  title,
  description,
  "slug": slug.current,
  "playbackId": coalesce(
    videoFile.asset->playbackId,
    videoFile.asset->data.playback_ids[0].id
  )
}`

function getMuxThumbnail(playbackId) {
  if (!playbackId) return placeholderImage

  return `https://image.mux.com/${playbackId}/thumbnail.jpg?time=1`
}

function VideosPage() {
  const [videos, setVideos] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    sanity
      .fetch(VIDEOS_QUERY)
      .then((result) => {
        setVideos(result || [])
        setLoading(false)
      })
      .catch((error) => {
        console.error(error)
        setLoading(false)
      })
  }, [])

  if (loading) return null

  return (
    <main className="min-h-screen px-4 pb-20 pt-24 text-[#5757fd] md:px-8">
      <section className="mx-auto max-w-7xl">
        <div className="mb-12 max-w-3xl">
          <p className="mb-4 w-fit rounded-full bg-white px-4 py-2 text-sm font-sans_bold">
            Verhalen
          </p>

          <h1 className="font-sans_bold text-5xl leading-none tracking-tight md:text-7xl">
            Videos
          </h1>

          <p className="mt-6 max-w-2xl font-sans text-lg leading-tight md:text-xl">
            Korte videoportretten en gesprekken over de betekenis van herdenken,
            vieren en doorgeven.
          </p>
        </div>

        {videos.length > 0 ? (
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {videos.map((video) => (
              <Link
                key={video._id}
                to={`/videos/${video.slug}`}
                className="group block"
              >
                <div className="relative aspect-[9/16] overflow-hidden rounded-[2rem] bg-white shadow-sm transition-all duration-500 group-hover:-translate-y-3 group-hover:shadow-[0_18px_40px_rgba(87,87,253,0.22)]">
                  <img
                    src={getMuxThumbnail(video.playbackId)}
                    alt={video.title}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-[#5757fd]/50 via-transparent to-transparent" />

                  <div className="absolute left-4 top-4 flex h-12 w-12 items-center justify-center rounded-full bg-white text-[#5757fd]">
                    <Play className="ml-0.5 h-5 w-5 fill-current" />
                  </div>

                  <div className="absolute bottom-4 left-4 right-4">
                    <div className="w-fit max-w-full rounded-2xl bg-white px-4 py-3 text-left text-[#5757fd]">
                      <p className="text-sm font-sans_bold leading-tight">
                        {video.title}
                      </p>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <div className="rounded-[2rem] bg-white/60 p-12 text-center">
            <p className="font-sans text-lg">Nog geen videos gevonden.</p>
          </div>
        )}
      </section>
    </main>
  )
}

export default VideosPage